<template>
  <fieldset class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="vehicleChangeFrequency"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in vehicleChangeFrequencyOptions"
        :key="item.touchpointValue"
        :collectionName="'vehicleChangeFrequency'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :validationScope="validationScope"
        @vehicleChangeFrequency="submitVehicleChangeFrequency($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('vehicleChangeFrequency', 'message')">
      Please select an option.
    </span>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component,
  Prop,
  Vue,
  Inject
} from 'vue-property-decorator';
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import KeyValue from '../../models/KeyValue';
import { tokenService } from '../../services/TokenService';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class VehicleChangeFrequencyComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'vehicleChangeFrequency' })
  public keyName!: string;

  @Prop({
    default: () => [new KeyValue('Every Year', 'EveryYear'),
      new KeyValue('Every 1-3 Years', '1to3Years'),
      new KeyValue('3 Years +', '3YearsPlus'),
      new KeyValue('First vehicleType purchase', 'FirstCarPurchase')]
  })
  public options!: KeyValue[];

  @Prop({ default: 'How often do you change vehicleType?' })
  public vehicleChangeFrequencyLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  private get vehicleChangeFrequencyOptions(): Touchpoint[] {
    return this.options.map((a: KeyValue) => new Touchpoint(a.value, tokenService.replaceToken(a.key)));
  }

  public submitVehicleChangeFrequency(value: string) {
    const extraData: ExtraData = new ExtraData(this.keyName, value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    this.validateComponent();
  }

  public get vehicleChangeFrequency() {
    return tokenService.replaceToken(this.vehicleChangeFrequencyLabel);
  }

  public validateComponent() {
    this.$validator.validateAll(this.validationScope);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public created() {
    this.validateComponent();
  }
}
</script>
